var map = {
	"./asl.svg": 856,
	"./banking_circle.svg": 857,
	"./currency_cloud.svg": 858,
	"./dragonpay.svg": 859,
	"./gb_prime.svg": 860,
	"./ocbc.svg": 482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 855;